import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import useApp from 'reducers/hooks/useApp';
import UserPresenter from 'presenters/UserPresenter';
import StatePresenter, { getStatesOptions } from 'presenters/StatePresenter';
import Loader from 'sharedComponents/Loader';
import Title from '../Title';
import LicensedStatesFrom from './components/LicensedStatesForm';
import useStyles from './useStyles';

const LicensedStates = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { onBack, states, isLoadingStates } = props;
  const { updateLoanOfficer, isUpdating, currentUser } = useApp();

  const statesOptions = getStatesOptions(states);

  const handleSubmit = async (values, { setErrors }) => {
    try {
      const attr = UserPresenter.buildUserUpdateAttributes(currentUser, values);
      await updateLoanOfficer(attr);
    } catch (error) {
      setErrors(error);
    }
  };

  const title = t('components.LoanOfficerSettings.title.licensedStates');

  const isFetching = isUpdating || isLoadingStates;
  if (isFetching) return <Loader fullFill />;

  return (
    <div className={classes.container}>
      <Title text={title} onBack={onBack} />
      <LicensedStatesFrom onSubmit={handleSubmit} currentUser={currentUser} states={statesOptions} />
    </div>
  );
};

LicensedStates.propTypes = {
  onBack: PropTypes.func.isRequired,
  states: PropTypes.arrayOf(StatePresenter.shape()).isRequired,
  isLoadingStates: PropTypes.bool.isRequired,
};

export default LicensedStates;



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/LicensedStates/LicensedStates.js